export default __webpack_public_path__ + "static/media/sounds/clpl_model_sentence_end_Alyx.mp3";